import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DatastoreComponent} from './datastore.component';
import {ComponentsModule} from '../../../components/components.module';
import {PanelModule} from 'primeng/panel';
import {ButtonModule} from 'primeng/button';
import {TableModule} from 'primeng/table';
import {RouterModule} from '@angular/router';
import {SplitButtonModule} from 'primeng/splitbutton';
import {DatastoreDetailsComponent} from './datastore-details/datastore-details.component';
import {InputTextModule} from 'primeng/inputtext';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DialogModule} from 'primeng/dialog';
import {TranslateModule} from '@ngx-translate/core';
import {ListboxModule} from "primeng/listbox";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {PipesModule} from '../../../pipes/pipes.module';
import {PasswordModule} from "primeng/password";
import {CheckboxModule} from "primeng/checkbox";
import {ToastModule} from 'primeng/toast';
import {TooltipModule} from 'primeng/tooltip';
import {ChipsModule} from 'primeng/chips';
import {InputGroupModule} from 'primeng/inputgroup';
import {InputGroupAddonModule} from 'primeng/inputgroupaddon';
import {FileConnectionsModule} from '../file-connections/file-connections.module';

@NgModule({
    declarations: [DatastoreComponent, DatastoreDetailsComponent],
    imports: [
        CommonModule,
        ComponentsModule,
        PanelModule,
        ButtonModule,
        TableModule,
        RouterModule,
        SplitButtonModule,
        InputTextModule,
        FormsModule,
        ReactiveFormsModule,
        DialogModule,
        TranslateModule,
        ListboxModule,
        ConfirmDialogModule,
        PipesModule,
        PasswordModule,
        CheckboxModule,
        ToastModule,
        TooltipModule,
        ChipsModule,
        InputGroupModule,
        InputGroupAddonModule,
        FileConnectionsModule
    ],
    exports: [DatastoreComponent]
})
export class DatastoreModule { }
